import type { ObjectValues } from "@/src/shared/types/objectValues";
import { DS_SIZE } from "@/src/design_system/shared/types/size";

export const DS_CONTENT_CONNECTOR_SIZES = {
  Medium: DS_SIZE.Medium,
  Large: DS_SIZE.Large,
} as const;

export type DSContentConnectorSize = ObjectValues<typeof DS_CONTENT_CONNECTOR_SIZES>;
